import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { begruessung } from '../ui/begruessung.js';
import stile from './banner.module.css';

/** Von Tim am 2026-10-01 geliefert (ERGO-Turm), 2400 x 800; dieselbe Montage wie in der Content-Factory. */
export const BANNER_BILD = '/marke/banner-ergo-turm.jpeg';

export function Banner({
  bild,
  email,
  name = null,
  jetzt,
  links = null,
}: {
  bild: string | null;
  email: string | null;
  /** Anzeigename des Kontos; fehlt er, kommt der Vorname aus der Adresse. */
  name?: string | null;
  jetzt: Date;
  /**
   * Links in der Zeile unter dem Banner, gegenueber von "Neuen Auftrag anlegen" -- dort steht der
   * Umschalter der Gesamtansicht. In dieser Zeile fluchtet er mit dem Banner; als eigenes Element
   * der Seite stand er ausserhalb der Inhaltsspalte (Rueckmeldung 2026-10-15).
   */
  links?: ReactNode;
}) {
  return (
    <>
      <section className={stile.banner} aria-label="Begrüßung">
        {bild && <img className={stile.bild} src={bild} alt="" decoding="async" />}
        <div className={stile.text}>
          <p className={stile.gruss}>{begruessung(jetzt, email, name)}</p>
          <p className={stile.unterzeile}>Willkommen in der Content Engine der ERGO Direkt.</p>
        </div>
      </section>
      <div className={stile.aktionen}>
        {links && <div className={stile.links}>{links}</div>}
        <Link className="eds-button eds-button--primary" to="/neu">
          Neuen Auftrag anlegen
        </Link>
      </div>
    </>
  );
}
